import { Box } from "@mui/material";
import notificationIcon from "../../assets/notification.png";

interface NotificationsIconProps {
  children?: React.ReactNode;
  fontSize?: number | string;
  color?: string;
  width?: number | string;
  height?: number | string;
}

const NotificationsIcon: React.FC<NotificationsIconProps> = (props) => {
  const { width = "19px", height = "19px" } = props;
  return (
    <Box
      component="img"
      src={notificationIcon}
      alt="Notifications"
      sx={{
        width,
        height,
        display: "block",
      }}
    />
  );
};

export default NotificationsIcon;
